module.exports = __webpack_public_path__ + "static/media/friendScreenshot.214f0b22.png";